export const CLAVEBUSQUEDA = '14f9d8d012627aeb7f5da9948b93b44e'

export const CLAVEESCRITURA = '6108b86dceb55f07f6cd5ab54c39b912'

export const CLAVEAPP = 'T2WAAARIX9'